import { fetchJsonWithCache } from './cache';

export interface MatchesParams {
  days?: number;
  competition?: string;
  season?: string;
  friendlies?: boolean;
  id?: number;
}

function paramsToKey(params: MatchesParams): string {
  return `matches:${JSON.stringify(params)}`;
}

export function fetchMatches(params: MatchesParams = {}): Promise<unknown> {
  const qp = new URLSearchParams();
  if (params.days) qp.set('days', String(params.days));
  if (params.competition) qp.set('competition', params.competition);
  if (params.season) qp.set('season', params.season);
  if (params.friendlies) qp.set('friendlies', 'true');
  if (params.id) qp.set('id', String(params.id));

  const qs = qp.toString();
  const url = qs ? `/matches?${qs}` : '/matches';

  return fetchJsonWithCache({
    url,
    cacheKey: paramsToKey(params),
  });
}

export function bustMatchesCache(): void {
  import('idb-keyval').then(({ keys, del }) => {
    keys().then((all: IDBValidKey[]) => {
      const matchKeys = all.filter(
        (k) => typeof k === 'string' && k.startsWith('streampitch:matches:')
      );
      Promise.all(matchKeys.map((k) => del(k)));
    });
  });
}
